var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuyana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4a926d",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m0 24 30-12L0 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6c644",
    d: "M0 23V1l27.3 11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m0 24 14-12L0 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b02d30",
    d: "M0 1.25v21.5L12.46 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyana);
export default __webpack_public_path__ + "static/media/guyana.bed0e77c24adb30032e95a96dbe497f3.svg";
export { ForwardRef as ReactComponent };